(() => {
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  const itemSelector = [
    ".lumihi-section__header",
    ".lm-editorial__media",
    ".lm-editorial__content",
    ".lm-card",
    ".lm-tabs__tab",
    ".lm-tabs__link",
    ".product-grid > .grid__item",
    ".collection-list > .grid__item",
    ".multicolumn-list > .grid__item",
    ".collage__item",
    ".blog__post",
    ".footer-block",
    ".lm-trust-item",
    ".lm-promise__row",
    ".accordion",
    ".lm-brand-story__copy",
    ".lm-brand-story__media",
    ".lm-brand-story__quote",
    ".lm-brand-story__value",
    ".lm-journal__header",
    ".lm-journal__card",
  ].join(",");
  let observer;

  const revealNow = (element) => element.classList.add("lm-reveal-visible");

  const prepare = (root = document) => {
    const scope = root.matches?.(".shopify-section") ? root : root;
    const elements = [...scope.querySelectorAll(itemSelector)].filter(
      (element) => {
        if (
          element.dataset.lmReveal !== undefined ||
          element.closest("[hidden]")
        )
          return false;
        return element.getClientRects().length > 0;
      },
    );

    elements.forEach((element) => {
      element.dataset.lmReveal = element.matches(".lm-editorial__media")
        ? "fade"
        : "up";
      const group = element.parentElement?.querySelectorAll(
        `:scope > ${element.tagName.toLowerCase()}`,
      );
      const index = group ? Math.min([...group].indexOf(element), 7) : 0;
      element.style.setProperty(
        "--lm-reveal-delay",
        `${Math.max(index, 0) * 70}ms`,
      );
      if (reduceMotion.matches || !observer) revealNow(element);
      else observer.observe(element);
    });

    // Shopify policies often render their entire long-form copy in one very tall
    // paragraph. A ratio-based observer may never reach its threshold on mobile,
    // so policy content must never depend on reveal animation to become visible.
    scope
      .querySelectorAll(".shopify-policy__container [data-lm-reveal]")
      .forEach(revealNow);
  };

  const start = () => {
    document.documentElement.classList.add("lm-reveal-ready");
    if (!reduceMotion.matches && "IntersectionObserver" in window) {
      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            revealNow(entry.target);
            observer.unobserve(entry.target);
          });
        },
        { rootMargin: "0px 0px -8% 0px", threshold: 0.08 },
      );
    }
    prepare();
  };

  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", start, { once: true });
  else start();

  document.addEventListener("shopify:section:load", (event) =>
    prepare(event.target),
  );
  reduceMotion.addEventListener?.("change", (event) => {
    if (event.matches)
      document.querySelectorAll("[data-lm-reveal]").forEach(revealNow);
  });
})();
